// Is a given variable an object?
export default function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isObject.js
// module id = 55
// module chunks = 0